// Filename: hamburger.js
// Last Updated: April 25, 2024
// Project: UHN Foundation Sub Sites

document.addEventListener('DOMContentLoaded', function () {
  const background = document.getElementById('mobileNav');
  const hamburgerCheckbox = document.getElementById('hamburgerCheckbox');
  const hamburgerLabel = document.getElementById('hamburgerLabel');
  const mobileNav = document.getElementById('mobileNav');
  const menuLinks = mobileNav.querySelectorAll('.mobile-header__nav-link');

  background.addEventListener('click', function () {
    hamburgerCheckbox.click(); // Simulate a click on the checkbox
  });

  /**
   * Function: hideMenuLinks
   *
   * Description:
   *   This function removes menu links from the tab order when a specific condition is met.
   *   It iterates through an array of menu links and sets their `tabindex` attribute to `-1`, effectively removing them from the tab order.
   *
   * Parameters:
   *   None
   *
   * Usage:
   *   Call this function when you want to remove menu links from the tab order.
   *   Ensure that `menuLinks` is properly defined as an array of DOM elements representing menu links.
   *
   * Example:
  //  *   // Assuming menuLinks is an array of DOM elements representing menu links
   *   const menuLinks = document.querySelectorAll('.menu-link');
   *
  //  *   // Call hideMenuLinks function when needed
   *   hideMenuLinks();
   */
  const hideMenuLinks = () => {
    // If checkbox is unchecked (menu is closed), remove menu links from tab order
    menuLinks.forEach(link => {
      link.setAttribute('tabindex', '-1');
    });
    // Restore scrolling behavior
    document.body.style.overflow = '';
    mobileNav.style.overflow = 'hidden';
    mobileNav.style.transform = 'translateY(-100%)';

    // ! On page load, the dropdown menu displays before moving off the screen.
    // mobileNav.style.transition = 'transform 0.5s ease-in-out';
  };

  hideMenuLinks();

  /**
   * Function: trapMenuFocus
   *
   * Description:
   *   This function traps focus within the menu when the hamburger checkbox is toggled.
   *   When the checkbox is checked (indicating the menu is open), it sets the `tabindex`
   *   of menu links and the hamburger checkbox itself to `0`, allowing keyboard navigation
   *   within the menu. When the checkbox is unchecked (indicating the menu is closed),
   *   it hides menu links from the tab order using the `hideMenuLinks` function and sets
   *   the `tabindex` of the hamburger checkbox to `-1`, removing it from the tab order.
   *
   * Parameters:
   *   None
   *
   * Usage:
   *   Call this function to trap focus within the menu when the hamburger checkbox is toggled.
   *   Ensure that `hamburgerCheckbox` and `menuLinks` are properly defined before calling this function.
   *
   * Example:
  //  *   // Assuming hamburgerCheckbox and menuLinks are properly defined
   *   trapMenuFocus();
   */
  const trapMenuFocus = () => {
    hamburgerCheckbox.addEventListener('change', function () {
      if (hamburgerCheckbox.checked) {
        // If checkbox is checked (menu is open), set tabindex of menu links to 0
        menuLinks.forEach(link => {
          link.setAttribute('tabindex', '0');
        });
        hamburgerCheckbox.setAttribute('tabindex', '0');
        // Disable scrolling when menu is open
        document.body.style.overflow = 'hidden';
        mobileNav.style.overflow = 'auto';
        mobileNav.style.transform = 'translateY(0)';
      } else {
        hideMenuLinks();
        hamburgerCheckbox.setAttribute('tabindex', '-1');
      }
    });
  };

  trapMenuFocus(); // Call initially to set tabindex based on checkbox state

  hamburgerCheckbox.addEventListener('change', trapMenuFocus);

  // Add event listeners to handle focusing on the last/first menu item
  menuLinks.forEach((link, index) => {
    link.addEventListener('keydown', event => {
      if (
        event.key === 'Tab' &&
        !event.shiftKey &&
        index === menuLinks.length - 1
      ) {
        // If Tab is pressed and it's the last menu item, focus on the hamburgerCheckbox
        hamburgerCheckbox.focus();
        event.preventDefault();
      } else if (
        event.key === 'Tab' &&
        event.shiftKey &&
        index === 0 &&
        !hamburgerCheckbox.checked
      ) {
        // If Shift + Tab is pressed and it's the first menu item and menu is closed, focus on the hamburgerCheckbox
        hamburgerCheckbox.focus();
        event.preventDefault();
      }
    });
  });

  hamburgerLabel.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === '') {
      // Enter key or Spacebar

      hamburgerCheckbox.click(); // Toggle the checkbox
    }
  });
});
